import styles from './Mockup.module.scss';
import { useEffect, useRef, useState, createRef, useLayoutEffect } from 'react';
import axios from '../../config/axios';
import axiosV2 from 'axios';
import { Resizable } from 're-resizable';
import html2canvas from 'html2canvas';
import { useScreenshot } from 'use-react-screenshot'
import { SketchPicker } from 'react-color'
import EXIF from 'exif-js';
import ProductModal from '../../Components/ProductModal/ProductModal1';
import ProductModal2 from '../../Components/ProductModal/ProductModal2';
import ActionAlert from '../../Components/ProductModal/ActionAlert';
import BulePrint from '../../Components/ProductModal/BulePrint';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import Layout from '../../Components/Layout/Layout';
import { Row, Col, Checkbox, Input, message, Tooltip, Modal, Alert, InputNumber, Select, Slider } from 'antd';
import Loader from '../../Components/Loader/Loader';
import { FaUpload, FaRegSmile, FaCheck } from 'react-icons/fa';
import { GiCheckMark } from 'react-icons/gi';
import { IoIosCloseCircle } from 'react-icons/io';
import { AiOutlineEdit } from 'react-icons/ai';
import { BsArrowLeft } from 'react-icons/bs';
import DragResizeContainer from 'react-drag-resize';
import { getUniqueArr } from '../../utils';
import { MdConstruction } from 'react-icons/md';
import ResizableRectTouch from "react-resizable-rotatable-draggable-touch-v2";

const Mockup = (props) => {
    
    const [inputValue, setInputValue] = useState(1);
    const tui = useRef(null);
    const [designEdit, setDesignEdit] = useState(false);
    const [mockupLoading, setMockupLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState({});
    const [variants, setVariants] = useState([]);
    const [image, setImage] = useState(null);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [agreed, setAgreed] = useState(false);

    const [sizes, setSizes] = useState([]);
    const [bulePrint, setBulePrint] = useState(0);
    const [blackAction, setBlackAction] = useState(0);
    const [blackActionView, setBlackActionView] = useState(0);
    const [colors, setColors] = useState([]);
    const [selectedSize, setSelectedSize] = useState('');
    const [handler, setHandler] = useState('');
    const [xhr, setXhr] = useState(false);
    const [designImg, setDesignImg] = useState(null);
    const [designImgTemp, setDesignImgTemp] = useState(null);
    const [mockupImg, setMockupImg] = useState(null);
    const [mockupImgArray, setMockupImgArray] = useState([]);
    const [gridShow, setGridShow] = useState(0);
    const [gridImgShow, setGridImgShow] = useState(0);
    const [grid_size, setGridsize] = useState(7);
    const [array_grid, setArrayGrid] = useState([]);
    const [rotate_d, setRotate] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [viewDesignImg, setViewDesignImg] = useState(1);
    const [viewDesignAgree, setViewDesignAgree] = useState(null);
    const [showBorder, setShowBorder] = useState(false);
    const [mockup, setMockup] = useState({});
    const [hidden, setHidden] = useState(true);
    const [mockupData, setMockupData] = useState({});
    const [eMockupData, setEMockupData] = useState(null);
    const [mockOptions, setMockOptions] = useState([]);
    const [eMockOptions, setEMockOptions] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [addText, setAddText] = useState(false);
    const [text, setText] = useState('');
    const [fs, setFs] = useState(12);
    const [fColor, setFColor] = useState('#000');
    const [fWeight, setFWeight] = useState(600);
    const [showCAModal, setShowCAModal] = useState(false);
    const [cliparts, setCliparts] = useState([]);
    const [pType, setPType] = useState('dtg');
    const [overflow, setOverflow] = useState(false);
    const [wait, setWait] = useState(false);
    const [curWidth, setCurWidth] = useState(0);
    const [curHeight, setCurHeight] = useState(0);
    const [curPlacement, setCurPlacement] = useState('');
    const [printFile, setPrintFile] = useState('');

    var colorArray = ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];

    var htmlToImage = require('html-to-image');
    
    const [optionList, setOptionList] = useState([]);
    const [showGuide, setShowGuide] = useState(false);
    const [imageList, setImageList] = useState([]);
    const search = props.location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);
    const dImgRef = useRef(null);
    const [designAgree, setDesignAgree] = useState(0);;

    const ref = createRef(null)
    const [snap, takeScreenshot] = useScreenshot()
    const getImage = () => takeScreenshot(ref.current)
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState('');
    const [actualWidth, setActualWidth] = useState(0);
    const [actualHeight, setActualHeight] = useState(0);
    const [viewMode, setViewMode] = useState(1);
    const [ca, setCa] = useState(false);
    const [viewPng, setViewPng] = useState(1);
    const [viewPng1, setViewPng1] = useState(0);
    const [zoom, setZoom] = useState(1);

    const layout = [{ key: 'test', x: 0, y: 0, width: 200, height: 100, zIndex: 1 }]
    const canResizable = (isResize) => {
        return { top: isResize, right: isResize, bottom: isResize, left: isResize, topRight: isResize, bottomRight: isResize, bottomLeft: isResize, topLeft: isResize };
    };

    const [width, setWidth] = useState(80)
    const [height, setHeight] = useState(80)
    const [initwidth, setInitWidth] = useState(80)
    const [initheight, setInitHeight] = useState(80)
    const [top, setTop] = useState(0)
    const [left, setLeft] = useState(0)
    const [rotateAngle, setRotateAngle] = useState(0)
  
    const contentStyle = {
        top,
        left,
        width,
        height,
        position: 'absolute',
        transform: `rotate(${rotateAngle}deg)`
    }
    useEffect(() => {
    	if(designImg){
		if(blackAction){
		    setDesignImgTemp(designImg);
		    var myImg = new Image();
		    myImg.src = designImg;
		    myImg.onload = function() {
			    var canvas = document.createElement("canvas");
			    var ctx = canvas.getContext("2d");
			    canvas.width = myImg.width;
			    canvas.height=  myImg.height;
			    ctx.drawImage(myImg,0,0);
			    var imgd = ctx.getImageData(0, 0, myImg.width, myImg.height);
			    var i=0;
			    for (i = 0; i <imgd.data.length; i += 4) {
				// change these values (RGB) to output new colors
				/*if(imgd.data[i] >= 200 && imgd.data[i+1] >= 200 && imgd.data[i+2] >= 200){
						imgd.data[i]   = 0;
						imgd.data[i+1] = 0;
						imgd.data[i+2] = 0;
					}else{
						imgd.data[i]   = (imgd.data[i]+imgd.data[i+1]+imgd.data[i+2])/3;
						imgd.data[i+1] = (imgd.data[i]+imgd.data[i+1]+imgd.data[i+2])/3;
						imgd.data[i+2] = (imgd.data[i]+imgd.data[i+1]+imgd.data[i+2])/3;
					}*/
					imgd.data[i+3] = 180;
			 }
			    ctx.putImageData(imgd, 0, 0);
			    setDesignImg(canvas.toDataURL("image/png"));
		    }
		}else{
			setDesignImg(designImgTemp);
		}
	}
    }, [blackAction]);

    const onChangeSlider = (newValue) => {
        setInputValue(newValue);
        setWidth(initwidth*newValue)
        setHeight(actualHeight*Math.round(initwidth*newValue)/actualWidth)
        setTop(top-(actualHeight*Math.round(initwidth*newValue)/actualWidth-height)/2)
        setLeft(left-(initwidth*newValue-width)/2)
    };

    const ViewDM = ()=>{
	
	    setWait(false);
        var fffff = Date().toLocaleString() + ".png";
	    htmlToImage.toPng(document.getElementById('div_area'))
	    .then(function (dataUrl) {
	    var i;
            if((designImg || text) && selectedVariant.id){
                setMockupLoading(true)
    		    var files_data =  [
                    {
                        "placement": curPlacement,
                        "image_url": "https://server-riww6.ondigitalocean.app/public/images/"+ fffff,
                        "position": {
                            "area_width": printFile.data.result.printfiles[0].width,
                            "area_height": printFile.data.result.printfiles[0].height,
                            "width": printFile.data.result.printfiles[0].width,
                            "height": printFile.data.result.printfiles[0].height,
                            "top": 0,
                            "left": 0
                        }
                    }
			    ]
		        for(i=0; i<imageList.length; i++){
		            if(!(imageList[i].includes(mockup.template_id)) && imageList[i][8]){
			     	    files_data = files_data.concat({"placement": imageList[i][7], "image_url": "https://server-riww6.ondigitalocean.app/public/images/"+imageList[i][8], "position": {"area_width": printFile.data.result.printfiles[0].width, "area_height": printFile.data.result.printfiles[0].height, "width": printFile.data.result.printfiles[0].width, "height": printFile.data.result.printfiles[0].height, "top": 0,"left": 0}})
        			}
		        }
		        var datas = {
                    "variant_ids": [
                        selectedVariant.id
                    ],
                    "format" : "png",
                    "files" : files_data
                }
                var ddd = dataUrl.split(",")
                axios.post(`/printful/mockup-generator/images/${product.id}`,  {file : ddd[1], filename: fffff} ).then(response => {
		    var flag=0
                    for(i=0; i<imageList.length; i++){
                        if(imageList[i].includes(mockup.template_id)){
                        imageList[i][1] = designImg;
                        imageList[i][2] = height;
                        imageList[i][3] = width;
                        imageList[i][4] = top;
                        imageList[i][5] = left;
                        imageList[i][6] = rotateAngle;
                        imageList[i][7] = curPlacement;
                        imageList[i][8] = fffff;
                        flag=1;
                        }
                    }
                    if(flag==0){
                        imageList.push([mockup.template_id,designImg,height,width,top,left,rotateAngle,curPlacement,fffff]);
                    }
                    var interval1 = setInterval(() =>{
                        axios.post(`/printful/mockup-generator/create-task/${product.id}`,  {data : datas} ).then(response1 => {
                            if(response1.data.code == 200 ){
                                flag=0
                                var interval = setInterval(() =>{
                                    axios.get(`/printful/task?url=${response1.data.result.task_key}`).then(response2 => {
                                        if(response2.data.result.status === "completed"){
                                            setMockupImg(response2.data.result.mockups[0].mockup_url)
                                            setMockupImgArray(response2.data.result.mockups)
                                            setViewMode(0)
                                            setGridShow(1);
                                            setGridImgShow(1); 
                                            setViewDesignImg(0);
                                            flag=1
                                        }
                                        if(response2.data.result.status === "failed"){
                                            flag=1
                                        }
                                    });
                                    if(flag == 1){
                                    setMockupLoading(false)
                                    clearInterval(interval);
                                    clearInterval(interval1);
                                    setWait(false);
                                    }
                                }, 1000);
                            }else{
                                setWait(true);
                            }
                        });
                    }, 5000);
                });
		    }
	    });
    }
    const ViewD = ()=>{
    	setBlackAction(0);
    	setMockupImgArray([])
    	setMockupLoading(false)
    	setViewDesignImg(1);
        setViewMode(1) ;
        setGridShow(0);
        if(viewPng === 0){
            setGridImgShow(1); 
        }else{
            setGridImgShow(0); 
        }
    }
    const ChangeSize = (size)=>{
    	var i;
    	for(i = 0; i<variants.length; i++){
		if(variants[i].size === size && selectedVariant.color_code ===  variants[i].color_code){
		    window.location.href = `/mockup/${product.id}?image=${variants[i].image}&variant=${variants[i].id}`;
		}
	}

    }
    const getColors = (tt)=>{
	var colours = {"#f0f8ff":"aliceblue","#faebd7":"antiquewhite","#00ffff":"aqua","#7fffd4":"aquamarine","#f0ffff":"azure","#f5f5dc":"beige","#ffe4c4":"bisque","#000000":"black","#ffebcd":"blanchedalmond","#0000ff":"blue","#8a2be2":"blueviolet","#a52a2a":"brown","#deb887":"burlywood","#5f9ea0":"cadetblue","#7fff00":"chartreuse","#d2691e":"chocolate","#ff7f50":"coral","#6495ed":"cornflowerblue","#fff8dc":"cornsilk","#dc143c":"crimson","#00ffff":"cyan","#00008b":"darkblue","#008b8b":"darkcyan","#b8860b":"darkgoldenrod","#a9a9a9":"darkgray","#006400":"darkgreen","#bdb76b":"darkkhaki","#8b008b":"darkmagenta","#556b2f":"darkolivegreen","#ff8c00":"darkorange","#9932cc":"darkorchid","#8b0000":"darkred","#e9967a":"darksalmon","#8fbc8f":"darkseagreen","#483d8b":"darkslateblue","#2f4f4f":"darkslategray","#00ced1":"darkturquoise","#9400d3":"darkviolet","#ff1493":"deeppink","#00bfff":"deepskyblue","#696969":"dimgray","#1e90ff":"dodgerblue","#b22222":"firebrick","#fffaf0":"floralwhite","#228b22":"forestgreen","#ff00ff":"fuchsia","#dcdcdc":"gainsboro","#f8f8ff":"ghostwhite","#ffd700":"gold","#daa520":"goldenrod","#808080":"gray","#008000":"green","#adff2f":"greenyellow","#f0fff0":"honeydew","#ff69b4":"hotpink","#cd5c5c":"indianred","#4b0082":"indigo","#fffff0":"ivory","#f0e68c":"khaki","#e6e6fa":"lavender","#fff0f5":"lavenderblush","#7cfc00":"lawngreen","#fffacd":"lemonchiffon","#add8e6":"lightblue","#f08080":"lightcoral","#e0ffff":"lightcyan","#fafad2":"lightgoldenrodyellow","#d3d3d3":"lightgrey","#90ee90":"lightgreen","#ffb6c1":"lightpink","#ffa07a":"lightsalmon","#20b2aa":"lightseagreen","#87cefa":"lightskyblue","#778899":"lightslategray","#b0c4de":"lightsteelblue","#ffffe0":"lightyellow","#00ff00":"lime","#32cd32":"limegreen","#faf0e6":"linen","#ff00ff":"magenta","#800000":"maroon","#66cdaa":"mediumaquamarine","#0000cd":"mediumblue","#ba55d3":"mediumorchid","#9370d8":"mediumpurple","#3cb371":"mediumseagreen","#7b68ee":"mediumslateblue","#00fa9a":"mediumspringgreen","#48d1cc":"mediumturquoise","#c71585":"mediumvioletred","#191970":"midnightblue","#f5fffa":"mintcream","#ffe4e1":"mistyrose","#ffe4b5":"moccasin","#ffdead":"navajowhite","#000080":"navy","#fdf5e6":"oldlace","#808000":"olive","#6b8e23":"olivedrab","#ffa500":"orange","#ff4500":"orangered","#da70d6":"orchid","#eee8aa":"palegoldenrod","#98fb98":"palegreen","#afeeee":"paleturquoise","#d87093":"palevioletred","#ffefd5":"papayawhip","#ffdab9":"peachpuff","#cd853f":"peru","#ffc0cb":"pink","#dda0dd":"plum","#b0e0e6":"powderblue","#800080":"purple","#663399":"rebeccapurple","#ff0000":"red","#bc8f8f":"rosybrown","#4169e1":"royalblue","#8b4513":"saddlebrown","#fa8072":"salmon","#f4a460":"sandybrown","#2e8b57":"seagreen","#fff5ee":"seashell","#a0522d":"sienna","#c0c0c0":"silver","#87ceeb":"skyblue","#6a5acd":"slateblue","#708090":"slategray","#fffafa":"snow","#00ff7f":"springgreen","#4682b4":"steelblue","#d2b48c":"tan","#008080":"teal","#d8bfd8":"thistle","#ff6347":"tomato","#40e0d0":"turquoise","#ee82ee":"violet","#f5deb3":"wheat","#ffffff":"white","#f5f5f5":"whitesmoke","#ffff00":"yellow","#9acd32":"yellowgreen"};
    	var colors = [];
	var myImg = new Image();
	myImg.src = tt;
	myImg.onload = function() {
	    var canvas = document.createElement("canvas");
	    var ctx = canvas.getContext("2d");
	    canvas.width = myImg.width;
	    canvas.height=  myImg.height;
	    ctx.drawImage(myImg,0,0);
	    var imgd = ctx.getImageData(0, 0, myImg.width, myImg.height);
	    var i=0;
	    var hex,hex1,hex2,hex3;
	    var flag = 0;
	    for (i = 0; i <imgd.data.length; i += 4) {
		hex1 = imgd.data[i].toString(16);
		hex2 = imgd.data[i+1].toString(16);
		hex3 = imgd.data[i+2].toString(16);
		hex1 = hex1.length == 1 ? "0" + hex1 : hex1;
		hex2 = hex2.length == 1 ? "0" + hex2 : hex2;
		hex3 = hex3.length == 1 ? "0" + hex3 : hex3;
		hex="#"+hex1+hex2+hex3;
		if (typeof colours[hex] != 'undefined'){
			flag =0;
			for (var j=0;j<colors.length ; j++)
			{
				if(colours[hex] == colors[j])
				{
					flag =1;
				}
			}
			if(flag==0){
				colors.push(colours[hex]);
			}
		}
	   }
	   if(colors.length > 6){
		   setBulePrint(1);
		   //message.warning('user will only be able to use mockup and upload picture for "DTG Printing"',6);
		   setDesignImg(null);
	   }else{
		   setDesignImg(tt);
	   }
	}
    }
    const removeDesign = ()=>{
        setImageList(imageList.filter(list =>list[0] !== mockup.template_id));
        setDesignImg(null); 
        setText(''); 
        setAddText(false); 
        setOptionList(optionList.filter(list => list !== mockup.template_id))
    }

    
    const handleResize = ({ style: { top, left, width, height }, isShiftKey, type, event }) => {
	if(type=="t" || type=="b"){
            setWidth(Math.round(height)*actualWidth/actualHeight)
            setHeight(Math.round(height))
	        setInitWidth(Math.round(height)*actualWidth/actualHeight)
            setInitHeight(Math.round(height))
        }else{
            setWidth(Math.round(width))
            setHeight(actualHeight*Math.round(width)/actualWidth)
	        setInitWidth(Math.round(width))
            setInitHeight(actualHeight*Math.round(width)/actualWidth)
        }       
        setTop(Math.round(top))
        setLeft(Math.round(left))
    }

   const handleRotate = ({ rotateAngle, event }) => {
      setRotateAngle(rotateAngle)
   }

   const handleDrag = ({ deltaX, deltaY, event }) => {
        var x = left + deltaX;
        var y = top + deltaY;
        var xx;
        var yy;
        if(window.innerWidth >= 576){
            if(viewMode){
                yy = (mockup.print_area_height * 650) / mockup.template_height;
                xx = (mockup.print_area_width * 650) / mockup.template_width;
            }else{
                yy = (mockup.print_area_height * 650) / mockup.template_height;
                xx = (mockup.print_area_width * 650) / mockup.template_width;
            }
        }else{
            if(viewMode){
                yy = (mockup.print_area_height * 350) / mockup.template_height;
                xx = (mockup.print_area_width * 350) / mockup.template_width;
            }else{
                yy = (mockup.print_area_height * 350) / mockup.template_height;
                xx = (mockup.print_area_width * 350) / mockup.template_width;
            }
        }
        if ( x < 0 || y < 0 || x > xx || y> yy) {
            setOverflow(true);
        }else { 
            setOverflow(false); 
        }
        setLeft(left + deltaX);
        setTop(top + deltaY);
    }
   useEffect(() => {
	    if(viewPng1 == 1 ){
            if(product.id === 469 || product.id === 470 || product.id === 507 || product.id === 394 || product.id === 505  ||  product.id === 468 || product.id === 346 || product.id === 369){
                setImage("/mockup/" + product.id + "/" + curPlacement + ".png")
            }else{
                setImage(`https://server-riww6.ondigitalocean.app/api/printful/images?url=${mockup.image_url}`)
            }
            setViewPng1(2)
	    }
	   
    }, [text]);

    useEffect(() => {
        if (designImg) {
            if(viewPng1 == 1 ){
                if( product.id === 469 ||  product.id === 470 || product.id === 507 || product.id === 394 ||  product.id === 468 || product.id === 505 || product.id === 346 || product.id === 369){
                    setImage("/mockup/" + product.id + "/" + curPlacement + ".png");
                }else if(product.id === 631 && curPlacement === "front" ){
	    		setImage(`https://server-riww6.ondigitalocean.app/api/printful/images?url=https://files.cdn.printful.com/m/mens_windbreaker_kincustom/medium/templates/front_notext.png?v=1664125265`);
		}else if(product.id === 345){
	    		setImage("/mockup/346/" + curPlacement + ".png");
		}else{
                    setImage(`https://server-riww6.ondigitalocean.app/api/printful/images?url=${mockup.image_url}`)
                }
		
                setViewPng1(2);
            }
            document.querySelector("#designImg").addEventListener('load', function () {
                var image_width_actual = this.naturalWidth;
                var image_height_actual = this.naturalHeight;
                setActualWidth(image_width_actual);
                setActualHeight(image_height_actual);
                var temp_height;
                var temp_width;
                if(window.innerWidth >= 576){
                    if(viewMode){
                        temp_height = (mockup.print_area_height * 650) / mockup.template_height;
                        temp_width = (mockup.print_area_width * 650) / mockup.template_width;
                    }else{
                        temp_height = (mockup.print_area_height * 650) / mockup.template_height;
                        temp_width = (mockup.print_area_width * 650) / mockup.template_width;
                    }
                }else{
                    if(viewMode){
                        temp_height = (mockup.print_area_height * 350) / mockup.template_height;
                        temp_width = (mockup.print_area_width * 350) / mockup.template_width;
                    }else{
                        temp_height = (mockup.print_area_height * 350) / mockup.template_height;
                        temp_width = (mockup.print_area_width * 350) / mockup.template_width;
                    }
                }
                let flag = 0;
                for(let i=0; i<imageList.length; i++){
                    if(imageList[i].includes(mockup.template_id)){
                        setHeight(imageList[i][2]);
                        setWidth(imageList[i][3]);
                        setInitHeight(imageList[i][2]);
                        setInitWidth(imageList[i][3]);
                        setTop(imageList[i][4]);
                        setLeft(imageList[i][5]);
                        setRotateAngle(imageList[i][6]);
                        flag = 1;
                    }
                }
                if (!flag) {
                    if(temp_width/this.width>temp_height/this.height){
                        setWidth(Math.round(temp_width));
                        setHeight(Math.round(this.height*temp_width/this.width));
                        setInitWidth(Math.round(temp_width))
                        setInitHeight(Math.round(this.height*temp_width/this.width))
                        setLeft(0)
                        setTop((temp_height-this.height*temp_width/this.width)/2);
                    }else{
                        setHeight(Math.round(temp_height));
                        setWidth(Math.round(this.width*temp_height/this.height));
                        setInitWidth(Math.round(this.width*temp_height/this.height))
                        setInitHeight(Math.round(temp_height))
                        setTop(0)
                        setLeft((temp_width-this.width*temp_height/this.height)/2);
                    }
                    if(product.id === 19 || product.id === 300 || product.id === 403  || product.id === 407  || product.id === 382 || product.id === 585){
                        setHeight(Math.round(temp_height));
                        setWidth(Math.round(this.width*temp_height/this.height));
                        setInitWidth(Math.round(this.width*temp_height/this.height))
                        setInitHeight(Math.round(temp_height))
                        setTop(0)
                        setLeft((temp_width-this.width*temp_height/this.height)/2);
                    }
                }
            });
        }
    }, [designImg]);

    useEffect(() => {
        variants.forEach(variant => {
            if (variant.size === selectedVariant.size) {
                setColorOptions(colorOptions => colorOptions.concat(variant));
            }
        })

    }, [selectedVariant]);

    useEffect(() => {
        setCurWidth((mockup.print_area_width * 590) / mockup.template_width);
        setCurHeight((mockup.print_area_height * 600) / mockup.template_height);
    }, [designImg, dImgRef])

    useEffect(() => {
    	if(product){
            if(product.type === "EMBROIDERY"){
                setDesignAgree(0);
            }else{
                setDesignAgree(1);
            }
	}
        if (product.id) {
            axios.get('/public/categories').then(response => {
                setCategories(response.data);
                let index = response.data.findIndex(function (cat) {
                    return cat.product_id == product.id;
                });
                if (index >= 0) {
                    setCategory(response.data[index].category);
                } else {
                    console.log('not categorized');
                }
            });
            axios.get(`/printful/printfiles/${product.id}`).then(response => {
                setPrintFile(response);
            });
        }
    }, [product])

    useEffect(() => {

        axios.get('/public/cliparts').then(response => {
            setCliparts(response.data);
        });
	
        axios.get(`/printful/products/${props.match.params.id}`).then(response => {
            setLoading(true);
            setProduct(response.data.result.product);
            if (params.get('image')) {
                setImage(`https://server-riww6.ondigitalocean.app/api/printful/images?url=${params.get('image')}`)
                // setLoading(false);
                // setSelectedVariant(params.get('variant'));
            } else {
                // setImage(response.data.result.product.image)
                
                window.location.href = `/mockup/${response.data.result.product.id}?image=${response.data.result.variants[0].image}&variant=${response.data.result.variants[0].id}`;
                // props.history.push(`/mockup/${response.data.result.product.id}?image=${response.data.result.variants[0].image}&variant=${response.data.result.variants[0].id}`)
            }
            setVariants(response.data.result.variants);

            let index = response.data.result.variants.findIndex(function (variant) {
                return variant.id == params.get('variant')
            });
            if (params.get('variant')) {
                setSelectedVariant(response.data.result.variants[index]);
                setSelectedSize(response.data.result.variants[index].size);

                axios.get(`/printful/mockup/${props.match.params.id}`).then(responseV3 => {
                    setMockupData(responseV3.data.result);
                    axios.get(`/printful/mockup/${props.match.params.id}?technique=Embroidery`).then(responseV4 => {
                        if (responseV4.data.result.variant_mapping) {
                            if (responseV4.data?.result?.variant_mapping[0]?.templates[0]?.placement !== responseV3.data?.result?.variant_mapping[0]?.templates[0]?.placement) {
                                setEMockupData(responseV4.data.result);
                                for (let i = 0; i < responseV4.data.result.variant_mapping.length; i++) {
                                    if (responseV4.data.result.variant_mapping[i].variant_id == params.get('variant')) {
                                        setEMockOptions(responseV4.data.result.variant_mapping[i].templates);
                                    }
                                }
                            }
                        }
                        for (let i = 0; i < responseV3.data.result.variant_mapping.length; i++) {
                            if (responseV3.data.result.variant_mapping[i].variant_id == params.get('variant')) {
                                setMockOptions(responseV3.data.result.variant_mapping[i].templates);
                                for (let k = 0; k < responseV3.data.result.templates.length; k++) {
                                    if (responseV3.data.result.variant_mapping[i].templates[0].template_id == responseV3.data.result.templates[k].template_id) {
					                    var tttt = testimg(responseV3.data.result.templates[k].image_url, responseV3.data.result.templates[k].print_area_width, responseV3.data.result.templates[k].print_area_height, response.data.result.product,response.data.result.product.files[0].type)
                                        setMockup(responseV3.data.result.templates[k])
					                    setCurPlacement(responseV3.data.result.variant_mapping[0].templates[0].placement)
                                        setLoading(false);
                                    }
                                }
                            }
                        }
                    });

                });
            }

        });
	    setZoom(mockup.template_width*0.6/mockup.print_area_width);
	    function updateSize() {
		    var temp = gridShow;
		    setGridShow("");
		    setGridShow(temp);
	    }
	    window.addEventListener('resize', updateSize);
	 
	    return () => window.removeEventListener('resize', updateSize);
    }, []);

    //defining changeMockup function
    const changeMockup = (templateID,placement) => {
        for (let k = 0; k < mockupData.templates.length; k++) {
            if (templateID == mockupData.templates[k].template_id) {
	    	    var tttt = testimg(mockupData.templates[k].image_url, mockupData.templates[k].print_area_width, mockupData.templates[k].print_area_height, product,placement)
                    setMockup(mockupData.templates[k])
	            setLoading(false);
		        setOptionList(optionList => optionList.concat(mockupData.templates[k].template_id))
		        setTimeout(() => {
			        for(let i=0; i<imageList.length; i++){
			            if(imageList[i].includes(mockupData.templates[k].template_id)){
                            setDesignImg(imageList[i][1]);
                            setHeight(imageList[i][2]);
                            setWidth(imageList[i][3]);
                            setInitHeight(imageList[i][2]);
                            setInitWidth(imageList[i][3]);
                            setTop(imageList[i][4]);
                            setLeft(imageList[i][5]);
                            setRotateAngle(imageList[i][6]);
			            }
			        }
		        }, 1);
                
		        setZoom(mockupData.templates[k].template_width*0.6/mockupData.templates[k].print_area_width);
            }
        } 
    }
	
    function testimg(src, width, height,product,placement) {
    	if(src.includes("api-template")){
            setMockupLoading(true)
            var img = new Image();
            img.crossOrigin = 'anonymous';
            if( product.id === 469 || product.id === 470 || product.id === 507 || product.id === 394 || product.id === 505 ||  product.id === 468 || product.id === 346 || product.id === 369) {
                img.src = "/mockup/" + product.id + "/" + placement + ".png";
                
            }else if(product.id === 345){
	    	img.src = "/mockup/346/" + placement + ".png";
	    }else if(product.id === 631 && placement === "front" ){
		 img.src = `https://server-riww6.ondigitalocean.app/api/printful/images?url=https://files.cdn.printful.com/m/mens_windbreaker_kincustom/medium/templates/front_notext.png?v=1664125265`;
	    }else{
		img.src = `https://server-riww6.ondigitalocean.app/api/printful/images?url=${src}`;
            }
	   
            var canvas = document.getElementById('canvas');
            var ctx = canvas.getContext('2d');
            var pixel
            ctx.fillStyle = 'blue';
            ctx.fillRect(0, 0, 1000, 1000);
            if(viewPng1==2){
                if(viewPng == 0){
                    setImage(img.src)
                }else{
                    setImage(product.image);
                }

            }else{
                img.onload = function() {
                    ctx.drawImage(img, 0, 0);
                    pixel = ctx.getImageData(0, 0, width, height);
                    var i;
                    var flag = 1;
                    for (i = 0; i < pixel.data.length; i += 2048) {
                        if( pixel.data[i] > 0){
                            flag = 2		    	
                        }
                        if(flag == 2 &&  pixel.data[i]  == 0 && pixel.data[i+1]  == 0 && pixel.data[i+2]  == 255){
                            setImage(product.image);
                            setViewPng1(1);
                            setViewPng(0);
                            setGridImgShow(1);
                            setDesignEdit(true);
                            setMockupLoading(false);
                            return false;
                        }
                    }
                    if(flag == 1){
                        setViewPng1(0);
                        setViewPng(1);
                        setImage(product.image);
                    }else{
                        setImage(product.image);
                        setViewPng1(1);
                        setViewPng(1);
                    }
                    setMockupLoading(false);
                    return true;
                };
            }

	    }else{
            setViewPng(1);
            setViewPng1(0);
            setImage(`https://server-riww6.ondigitalocean.app/api/printful/images?url=${src}`)
            setMockupLoading(false);
            return true;
	    }
	
    }

    		

    const showgrid = () => {
        if(gridShow == 1){
            let temp = [];
            setArrayGrid(temp);
            setGridShow(0)
        }else{
            setGridShow(1)
        }

    }
    const Pushimag = ( mockupFlag,template_id,placement ) => {
        if(designImg){
            var fffff = Date().toLocaleString() + ".png";
            htmlToImage.toPng(document.getElementById('div_area'))
            .then(function (dataUrl) {
                setMockupLoading(true)
                var ddd = dataUrl.split(",")
                axios.post(`/printful/mockup-generator/images/${product.id}`,  {file : ddd[1], filename: fffff} ).then(response => {
                    let flag=0
		    if(viewDesignImg === 1){
			    for(let i=0; i<imageList.length; i++){
				if(imageList[i].includes(mockup.template_id)){
					imageList[i][1] = designImg;
					imageList[i][2] = height;
					imageList[i][3] = width;
					imageList[i][4] = top;
					imageList[i][5] = left;
					imageList[i][6] = rotateAngle;
					imageList[i][7] = curPlacement;
					imageList[i][8] = fffff;
					flag=1;
				}
			    }
			    if(flag==0){
				imageList.push([mockup.template_id,designImg,height,width,top,left,rotateAngle,curPlacement,fffff]);
			    }
			}
                    setDesignImg(null);
                    setCurPlacement(placement);
                    if (mockupFlag == "mockup"){
                        changeMockup(template_id,placement);
                    }else{
                        changeEMockup(template_id);
                    }
                    setHeight(80);
                    setWidth(80);
                    setInitHeight(80);
                    setInitWidth(80);
                    setTop(10);
                    setLeft(10);
                    setRotateAngle(0);
                    ViewD();

                });
            });
        }else{
            for(let i=0; i<imageList.length; i++){
                if(imageList[i].includes(mockup.template_id)){
                    imageList[i][1] = null;
                    imageList[i][2] = height;
                    imageList[i][3] = width;
                    imageList[i][4] = top;
                    imageList[i][5] = left;
                    imageList[i][6] = rotateAngle;
                    imageList[i][7] = "";
                    imageList[i][8] = "";
                        
                }
            }
            setDesignImg(null);
            setCurPlacement(placement);
            if (mockupFlag == "mockup"){
                changeMockup(template_id,placement);
            }else{
                changeEMockup(template_id);
            }
            setHeight(80);
            setWidth(80);
            setInitHeight(80);
            setInitWidth(80);
            setTop(10);
            setLeft(10);
            setRotateAngle(0);
            ViewD();
        }
       
    }
  
    
    
    //defining changeMockup function
    const changeEMockup = (templateID,placement) => {
        for (let k = 0; k < eMockupData.templates.length; k++) {
            if (templateID == eMockupData.templates[k].template_id) {
                setImage(`https://server-riww6.ondigitalocean.app/api/printful/images?url=${eMockupData.templates[k].image_url}`)
                setMockup(eMockupData.templates[k])
                setLoading(false);
                for(let i=0; i<imageList.length; i++){
                    if(imageList[i].includes(eMockupData.templates[k].template_id)){
                        setDesignImg(imageList[i][1]);
                        setHeight(imageList[i][2]);
                        setWidth(imageList[i][3]);
			setInitHeight(imageList[i][2]);
                        setInitWidth(imageList[i][3]);
                        setTop(imageList[i][4]);
                        setLeft(imageList[i][5]);
                        setRotateAngle(imageList[i][6]);
                    }
                }
		setZoom(eMockupData.templates[k].template_width*0.6/eMockupData.templates[k].print_area_width);
            }
        }
	setMockupLoading(false)
    }

  

    useEffect(() => {
        if (variants.length > 0) {

            const filteredArr = variants.reduce((acc, current) => {
                const x = acc.find(item => item.size === current.size);
                if (!x) {
                    return acc.concat([current]);
                } else {
                    return acc;
                }
            }, []);

            setSizes(filteredArr);

            const filteredColorArr = variants.reduce((acc, current) => {
                const x = acc.find(item => item.color_code === current.color_code);
                if (!x) {
                    return acc.concat([current]);
                } else {
                    return acc;
                }
            }, []);

            setColors(filteredColorArr.filter(a => a.size !== selectedSize));
        }
    }, [variants, selectedSize]);


    //defining handleCheckout function
    const handleCheckout = () => {
        if (!handler) {
            message.error('Telegram/Twitter handler is required!');
        } else {
            setXhr(true);
            setHidden(false);
            let dataUrl;

            setTimeout(() => {
                let elem = document.getElementsByClassName('editorCap');
                html2canvas(elem[0], {
                    allowTaint: true,
                    useCORS: true
                }).then(canvas => {
                    dataUrl = canvas.toDataURL()
                    let payload = {
                        canvas: selectedVariant.image,
                        design: dataUrl,
                        size: selectedVariant.size,
                        color: selectedVariant.color_code,
                        price: parseFloat(selectedVariant.price).toFixed(2),
                        category: category,
                        sub_category: product.type_name,
                        handle: handler,
                        name: selectedVariant.name,
                        description: product.description,
                        product_id: product.id,
                        variant_id: selectedVariant.id
                    }

                    axiosV2.get(`http://api.unme.online/telegram/events?event_name=code_request&target=@${handler}`).then(rsp => {
                    });

                    axios.post('/products', payload).then(response => {
                        window.location.href = response.data.links[1].href;
                    });

                }

                )
            }, 1);
        }
    }

    function makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
        }

        return words.join(' ');
    }

    function getAdditional(name) {
        for (let i = 0; i < product.files.length; i++) {
            if (product.files[i].id == name) {
	    	var temp = parseFloat(product.files[i].additional_price) + 1;
                return temp;
            }
            // if (product.files[i].title.toLowerCase().includes(name.toLowerCase())) {
            // }
        }

        return 'incl';
    }


    //defining getDpi function
    function getDpi() {
        // var image_width_actual = document.querySelector("#designImg").naturalWidth;
        // var image_height_actual = document.querySelector("#designImg").naturalHeight;
    }



    //defining isOptionThere 
    const isOptionThere = (id) => {

    }



    return (
	
        <Layout
            title={'Mockup - Unme'}
        >
	    <canvas id="canvas" width="1000" height="1000" style={{ display: 'none' }} ></canvas>
            <section className={'container ' + styles.mockup}>
                {
                    loading ?
                        <Loader height={'80vh'} />
                        :
                        <Row gutter={[20, 20]} style={{margin: window.innerWidth <= 576 ? '-10px':'10px'}}>
                            <Col sm={window.innerWidth <= 1000 ? 24 : 12} order={window.innerWidth <= 1000 ? 2 : 1}>
                                <div className={styles.left}>
                                    <h1 onClick={() => {
                                        // image is already loaded
                                        if (document.querySelector("#designImg").complete) {
                                            var image_width_actual = document.querySelector("#designImg").naturalWidth;
                                            var image_height_actual = document.querySelector("#designImg").naturalHeight;
                                        }
                                        else {
                                            document.querySelector("#img-element").addEventListener('load', function () {
                                                var image_width_actual = this.naturalWidth;
                                                var image_height_actual = this.naturalHeight;

                                                var image_width_rendered = this.width;
                                                var image_height_rendered = this.height;
                                            });
                                        }

                                    }}>{product.title} {category} <br /> USD  ${parseFloat(selectedVariant.price*1.6).toFixed(2)}</h1>
                                    {/* <p>{product.description}</p> */}
                                    
                                    <br />

                                    <div className={styles.print_type1}>
                                        <span style={{ fontSize: '1rem', color: 'grey'}} >   Design  </span>
                                        <a><span onClick={() =>  setSelectedProduct(product)}  style={{ fontSize: '1rem', color: 'grey'}} >   <u> Product info & File templates </u>  </span></a>
                                    </div>
                                    
                                      <Input placeholder='Your Telegram/Twitter Handler' style={{ border: '1px solid grey' }} onChange={e => setHandler(e.target.value)} />

                                    <Checkbox style={{ marginTop: '1rem' }} onChange={() => { setAgreed(agreed ? false : true); setShowBorder(false); setHidden(false) }}>
                                        I understand and accept the <a onClick={() =>setShowGuide(true)} style={{ color: 'var(--color-blue)' }}>content guidelines</a>
                                    </Checkbox>

                                    <div className={styles.bbox}>
                                        <button onClick={() => props.history.push('/')}>Cancel</button>
                                        <button
                                            style={{ backgroundColor: agreed ? 'transparent' : 'var(--color-primary)', color: !agreed ? 'var(--color-light)' : null }}
                                            onClick={handleCheckout}
                                            disabled={!agreed || xhr}
                                        >
                                            {
                                                xhr ?
                                                    'Loading'
                                                    :
                                                    'Activate Contract'
                                            }
                                        </button>
                                    </div>
                                    <br />
                                    <br />
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', flexDirection: 'column' }}>
                                        <div style={{ marginBottom: '1rem', marginRight: '1rem', color: 'grey', fontWeight: 500 }}>
                                            <span>Size</span>
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {
                                                getUniqueArr(variants, 'size').map((variant, index) => {
                                                    return <span
                                                        key={index}
                                                        className={styles.size}
                                                        style={{
                                                            backgroundColor: selectedVariant.size === variant.size ? 'grey' : null,
                                                            color: selectedVariant.size === variant.size ? 'white' : null,
                                                            width: 'fit-content',
                                                            padding: '.5rem'
                                                        }}
                                                        onClick={() => {ChangeSize(variant.size);}}
                                                    >
                                                        {variant.size}
                                                    </span>
                                                })
                                            }
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', flexDirection: 'column' }}>
                                        <div style={{ marginBottom: '1rem', marginRight: '1rem', color: 'grey', fontWeight: 500 }}>
                                            <span>Color</span>
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {
                                                colorOptions.map((variant, index) => {
                                                    return <Tooltip key={index} title={variant.color}>
                                                        <span
                                                            key={index}
                                                            className={styles.size}
                                                            style={{
                                                                backgroundColor: variant.color_code,
                                                                // border: 'none'
                                                                // color: selectedVariant.size === variant.size ? 'white' : null
                                                            }}
                                                            onClick={() => {
                                                                window.location.href = `/mockup/${product.id}?image=${variant.image}&variant=${variant.id}`;
                                                            }}
                                                        >
                                                            {
                                                                selectedVariant.color_code === variant.color_code &&
                                                                <FaCheck size={20} color='beige' />
                                                            }
                                                        </span>
                                                    </Tooltip>
                                                })
                                            }
                                        </div>
                                    </div>


                                    {/* <h1 style={{ marginTop: '1rem' }}>Variants</h1>
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        {
                                            variants.map((variant, index) => {
                                                return <div className={styles.var}>
                                                    <span
                                                        key={index}
                                                        className={styles.color}
                                                        style={{ backgroundColor: variant.color_code }}
                                                        onClick={() => {
                                                            window.location.href = `/mockup/${product.id}?image=${variant.image}&variant=${variant.id}`;
                                                        }}
                                                    >
                                                        {
                                                            params.get('variant') == variant.id &&
                                                            <GiCheckMark color='grey' />
                                                        }
                                                    </span>
                                                    <p>{variant.size}</p>
                                                </div>
                                            })
                                        }
                                    </div> */}

                                    {/* <div className={styles.choice}>
                                        <h1>Variants</h1>
                                        <div style={{ marginTop: '.5rem', display: 'flex', flexWrap: 'wrap' }}>
                                            {
                                                variants.map((variant, index) => {
                                                    return <button
                                                        key={index}
                                                        style={{
                                                            // backgroundColor: variant.color_code,
                                                            border: variant.id == params.get('variant') ? `2px solid var(--color-blue)` : null
                                                        }}
                                                        onClick={() => {
                                                            setImage(variant.image);
                                                            window.location.href = `/mockup/${product.id}?image=${variant.image}&variant=${variant.id}`;
                                                        }}
                                                    >
                                                        <span>{variant.size}</span>
                                                        <p style={{ backgroundColor: variant.color_code }}></p>
                                                    </button>
                                                })
                                            }
                                        </div>
                                    </div> */}

                                    {/* <label htmlFor="" style={{ marginBottom: '.5rem', display: 'block' }}>
                                        To earn 30% from every sale, please write your social media @handle below. Send $1.00 via Paypal/Debit/Credit Card to gain access to moderation. When your design is approved, It will be posted on Difusee
                                        website
                                    </label> */}
                                  
				    {
                                        addText ?
                                            <div>
                                                <div>
                                                    <BsArrowLeft style={{ marginBottom: '.5rem', cursor: 'pointer' }} size={20} onClick={() => setAddText(false)} />
                                                    <textarea
                                                        onChange={e => setText(e.target.value)}
                                                        style={{ width: '100%', color: 'var(--color-primary)' }}
                                                        cols="30"
                                                        rows="2"
                                                        placeholder='Enter your text here'
                                                        className={styles.ta}
                                                    >
                                                    </textarea>
                                                </div>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '1rem', width: '30%' }}>
                                                        <span style={{ marginBottom: '.5rem', color: 'grey' }}>Font Size</span>
                                                        <InputNumber min={1} max={100} defaultValue={12} onChange={value => setFs(value)} />
                                                    </div>

                                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '1rem' }}>
                                                        <span style={{ marginBottom: '.5rem', color: 'grey' }}>Font Weight</span>
                                                        <Select
                                                            onChange={value => setFWeight(value)}
                                                            style={{ height: 'fit-content' }}
                                                            value={fWeight}
                                                        >
                                                            <Select.Option value={400}>400</Select.Option>
                                                            <Select.Option value={500}>500</Select.Option>
                                                            <Select.Option value={600}>600</Select.Option>
                                                            <Select.Option value={700}>700</Select.Option>
                                                            <Select.Option value={800}>800</Select.Option>
                                                        </Select>
                                                    </div>

                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: '1rem', width: '100%' }}>
                                                    <span style={{ marginBottom: '.5rem', color: 'grey' }}>Font Color</span>
                                                    {/* <SketchPicker
                                                        color={fColor}
                                                        onChange={(color) => setFColor(color.hex)}
                                                    /> */}
                                                    <div className={styles.colorssss}>
                                                        {
                                                            colorArray.map((color, index) => {
                                                                return <div
                                                                    style={{ backgroundColor: color }}
                                                                    onClick={() => { setFColor(color); }}
                                                                >
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className={styles.action}>
                                                <label onClick={() => { setCa(true); setOptionList(optionList => optionList.concat(mockup.template_id)); setViewDesignAgree(true); }} htmlFor={designAgree?"overlayUp":null} className={styles.action_button}>
                                                    <FaUpload size={20} />
                                                    <span style={{ color: 'grey'}}>Choose file</span>
                                                    {/* <p>User your own design</p> */}
                                                </label>
                                                <label onClick={() => { setShowCAModal(true); setCa(true); setOptionList(optionList => optionList.concat(mockup.template_id)) }} className={styles.action_button}>
                                                    <FaRegSmile size={20} />
                                                    <span>Add clipart</span>
                                                    {/* <p>Use your clipart for design</p> */}
                                                </label>
                                                <label onClick={() => { setAddText(true); setOptionList(optionList => optionList.concat(mockup.template_id)) }} className={styles.action_button}>
                                                    <AiOutlineEdit size={20} />
                                                    <span>Add text</span>
                                                    {/* <p>Create a text-based design</p> */}
                                                </label>
                                            </div>
                                    }
                                </div>
                            </Col>
			    
					
                            <Col sm={window.innerWidth <= 1000 ? 24 : 12} order={window.innerWidth <= 1000 ? 1 : 2} ref={ref}>
			    	<div className={styles.print_type1}>
                        <span style={{ fontSize: '0.9rem', color: 'grey'}}>   Choose technique  </span>
                        <a><span style={{ fontSize: '1rem', color: 'grey'}} onClick={() => { Pushimag( "mockup", mockup.template_id , curPlacement); }}>  <u>Design view</u>  </span></a>
			
                       <a><span style={{ fontSize: '1rem', color: 'grey'}} onClick={() => {ViewDM(); }}>  <u>Product view </u>  </span></a>            
                              
				    </div>
                                {
                                    eMockupData &&
                                    <div className={styles.print_type}>
                                        <span>Print Type</span>
                                        <button style={{
                                            border: pType === 'dtg' ? '2px solid var(--color-blue)' : null
                                        }} onClick={() => setPType('dtg')}>DTG Printing</button>
                                        <button style={{
                                            border: pType === 'Embroidery' ? '2px solid var(--color-blue)' : null
                                        }} onClick={() => setPType('Embroidery')}>Embroidery</button>
                                    </div>
                                }
                                {
                                    pType === 'dtg' ?
                                        <div className={styles.options}>
                                            {
                                                mockOptions.map((option, index) => {
                                                    return <span
                                                        onClick={() => {
                                                            
                                                            if (addText) {
                                                                setOptionList(optionList => optionList.concat(option.template_id))
                                                            }
							    Pushimag("mockup",option.template_id,option.placement);
                                                        }}
                                                        style={{
                                                            display: option.placement.includes('label') ? 'none' : null,
                                                            borderBottom: option.template_id == mockup.template_id ? '2px solid var(--color-primary)' : null,
                                                            width: 'fit-content',
                                                            textAlign: 'center',
                                                            marginRight: '3rem',
                                                            paddingBottom: '.2rem'
                                                        }}
                                                    >
                                                        {makeTitle(option.placement)}
                                                        <br />
                                                        {
                                                            getAdditional(option.placement)&& optionList.includes(option.template_id) ?
                                                                <span style={{ fontSize: '.6rem', color: 'grey', display: option.placement.includes('embroidery') ? 'none' : null }}>

                                                                    {
                                                                        getAdditional(option.placement) == 'incl' ?
                                                                            'incl.'
                                                                            :
                                                                            <>
                                                                                +${getAdditional(option.placement)}
                                                                            </>
                                                                    }

                                                                </span>
                                                                :
                                                                null
                                                            // <span style={{ fontSize: '.6rem', color: 'grey' }}>
                                                            //     incl.
                                                            // </span>
                                                        }
                                                    </span>
                                                })
                                            }

                                        </div>
                                        :
                                        <div className={styles.options}>
                                            {
                                                eMockOptions.map((option, index) => {
                                                    return <span
                                                        onClick={() => {
								Pushimag("emockup",option.template_id,option.placement);}}
                                                        style={{
                                                            display: option.placement.includes('label') ? 'none' : null,
                                                            borderBottom: option.template_id == mockup.template_id ? '2px solid var(--color-primary)' : null,
                                                            width: 'fit-content',
                                                            textAlign: 'center',
                                                            marginRight: '3rem',
                                                            paddingBottom: '.2rem'
                                                        }}
                                                    >
                                                        {makeTitle(option.placement)}
                                                    </span>
                                                })
                                            }

                                        </div>
                                }

                                {/* <span style={{ display: 'block', marginBottom: '.5rem', color: 'grey', fontWeight: 400, fontSize: '.8rem' }}>**Please keep your design inside the print area. Otherwise it'll be rejected.</span> */}
                                {
                                    (overflow && !text) &&
                                    <Alert
                                        message="Warning"
                                        description="Part of your design is outside print area!"
                                        type="warning"
                                        showIcon
                                        closable
                                        style={{ marginBottom: '1rem' }}
                                    />

                                }
				{
                                    (wait && !text) &&
                                    <Alert
                                        message="Warning"
                                        description="You've recently sent too many requests. Please wait."
                                        type="warning"
                                        showIcon
                                        closable
                                        style={{ marginBottom: '1rem' }}
                                    />

                                }

                                {
                                    (parseInt((actualHeight * actualWidth) / (curHeight / 2 * curWidth / 2) + 0) < 120 && !ca && designImg) &&
                                    <Alert
                                        message="Warning"
                                        description={`DPI: ${parseInt((actualHeight * actualWidth) / (curHeight / 2 * curWidth / 2) + 0)} - If you want even better print quality, please upload a larger image
                                        ` }
                                        type="warning"
                                        showIcon
                                        closable
                                        style={{ marginBottom: '1rem' }}
                                    />
                                }
				{
				mockupLoading ?
					<Loader height={'40vh'} />
				:
                                <div
                                    // style={{ backgroundImage: `url(${image})`, backgroundColor: mockup.background_color }}
                                    style={{ backgroundColor: viewMode ? mockup.background_color: 'white' }}
                                    className={styles.editor + " " + 'editorCap'}
                                    // className={styles.editor}
                                    onMouseEnter={() => {
                                        setShowBorder(true); setHidden(true);
                                        //setCurHeight(document.getElementById('designImg').clientHeight)
                                    }}
                                    onMouseLeave={() => {
                                        setShowBorder(false); setHidden(false)
                                    }}
                                    onTouchStart={() => { setShowBorder(true); setHidden(true) }}
                                    onTouchEnd={() => {
                                        setTimeout(() => {
                                            setShowBorder(false); setHidden(false)
                                        }, 300000)
                                    }}
                                    id="editorCap"
                                >
				<div  className={styles.guide} style={{ border: '0px', zIndex: 25,  width: '100%', background: 'white', top: '0px' }}>
						{
							
							mockupImgArray.map((item, index) => {
							    return <img src={item.mockup_url}  style={{ width:'50px', height: '50px' }}  onClick={() => {setMockupImg(item.mockup_url);}} / >
							   
							})
							
						}
				</div>
				<div    id="printRec"
					 className={styles.guide}
					style={window.innerWidth <= 576?
					{
						border: 0,
						zIndex: 2,
						width: '75px',
						height: '100px',
						top:  '0px',
						left: 250 + 'px',
					 }
					 :
					 {
						border: 0,
						zIndex: 2,
						width: '75px',
						height: '100px',
						top:  '0px',
						left: 510 + 'px',
					 }
					 }
					>
				<img id="grid_img" src={gridShow ? "/grid2.png" : "/grid1.png"}  style={{  display: gridImgShow  ? 'None' : null, width: '74px', height:'75px' }}  alt="" onClick={() => {
					if(gridShow == 0){
							setGridShow(1);
						}else{
							setGridShow(0);
						}
						showgrid();}}/ ><p></p>
				<img id="action_img" src={"/action.png"}  style={{  display: selectedVariant.color==="Black" && !gridImgShow  ? null:'None' , width: '50px', height:'50px' , margin:'10px'}}  alt="" onClick={() => {
					if(blackActionView === 0){
							setBlackActionView(1);
						}else{
							setBlackActionView(0);
						}
						}}/ >

				</div>
				<div  className={styles.guide}	style={{ border: 0, zIndex: viewPng?0:12, width: window.innerWidth <= 576? '350px': '650px', height: window.innerWidth <= 576? '350px': '650px'}} >
				 {
				    viewPng?
				    <img src={viewMode ? image : mockupImg}  style={{ width: '100%', height: '100%', backgroundColor: viewMode ? selectedVariant.color_code : 'None' }} className={styles.the_image} />
				    :
				    <img src={viewMode ? image : mockupImg}  style={{ width: '100%', height: '100%' }} className={styles.the_image} />
				  }
				</div>
				

					{
						window.innerWidth <= 576 ?
					    
						<div
						    className={designImg  ? 'None' : styles.guide}
						    style={{
							zIndex: viewPng?2:12,
							display: (designImg || text)  ? 'None' : null,
							width: (mockup.print_area_width * 350) / mockup.template_width < 350 ? (mockup.print_area_width * 350) / mockup.template_width + 'px': '350px',
							height: (mockup.print_area_height * 350) / mockup.template_height < 350 ?(mockup.print_area_height * 350) / mockup.template_height + 'px': '350px',
							top: (mockup.print_area_height * 350) / mockup.template_height < 350 ?((mockup.print_area_top * 350) / mockup.template_height) + 0 + 'px': '0px',
							left: (mockup.print_area_width * 350) / mockup.template_width < 350? (mockup.print_area_left * 350) / mockup.template_width + 0 + 'px': '0px',
							visibility: viewDesignImg?'visible':'hidden',
						    }}
						>
						
						    
						</div>
						:
						<div    
						    className={designImg ? 'null' : styles.guide}
						    style={{
							zIndex: viewPng?2:12,
							display: (designImg || text) ? 'None' : null,
							width: (mockup.print_area_width * 650) / mockup.template_width < 650 ? (mockup.print_area_width * 650) / mockup.template_width + 'px' :  '650px',
							height: (mockup.print_area_height * 650) / mockup.template_height < 650 ? (mockup.print_area_height * 650) / mockup.template_height + 'px' :  '650px',
							top: (mockup.print_area_height * 650) / mockup.template_height < 650 ?((mockup.print_area_top * 650) / mockup.template_height) + 0 + 'px': '0px',
							left:(mockup.print_area_width * 650) / mockup.template_width < 650? (mockup.print_area_left * 650) / mockup.template_width + 0 + 'px': '0px',
							visibility: viewDesignImg?'visible':'hidden',
						    }}
						>
						
						    
						</div>
					}
                                    {
                                        designImg || addText ?
                                            <>
                                                {
                                                    window.innerWidth <= 576 ?
						    
                                                        <div
                                                            className={gridShow ? 'None' : styles.guide}
                                                            style={{
                                                                zIndex: viewPng?2:12,
                                                                display: gridShow ? 'None' : null,
                                                                width: (mockup.print_area_width * 350) / mockup.template_width < 350 ? (mockup.print_area_width * 350) / mockup.template_width + 'px': '350px',
                                                               height: (mockup.print_area_height * 350) / mockup.template_height < 350 ?(mockup.print_area_height * 350) / mockup.template_height + 'px': '350px',
                                                                top: (mockup.print_area_height * 350) / mockup.template_height < 350 ?((mockup.print_area_top * 350) / mockup.template_height) + 0 + 'px': '0px',
                                                                left: (mockup.print_area_width * 350) / mockup.template_width < 350 ? (mockup.print_area_left * 350) / mockup.template_width + 0 + 'px': '0px',
                                                            }}
                                                        >
							
                                                            <div className={styles.pa}>Print Area</div>
                                                            <div className={styles.the_close_button} style={{
                                                                left: window.innerWidth<(mockup.print_area_width * 350) / mockup.template_width+50  ?  window.innerWidth  - 100 + 'px': (mockup.print_area_width * 350) / mockup.template_width - 25 + 'px'
                                                            }}>
                                                                <IoIosCloseCircle size={20} color={'red'} onClick={() => { removeDesign() }} />
                                                            </div>
                                                        </div>
                                                        :
                                                        <div    
                                                            className={gridShow ? 'null' : styles.guide}
                                                            style={{
                                                                zIndex: viewPng?2:12,
                                                                display: gridShow ? 'None' : null,
                                                                width: (mockup.print_area_width * 650) / mockup.template_width < 650 ? (mockup.print_area_width * 650) / mockup.template_width + 'px' :  '650px',
								height: (mockup.print_area_height * 650) / mockup.template_height < 650 ? (mockup.print_area_height * 650) / mockup.template_height + 'px' :  '650px',
                                                                top: (mockup.print_area_height * 650) / mockup.template_height < 650 ?((mockup.print_area_top * 650) / mockup.template_height) + 0 + 'px': '0px',
                                                                left:(mockup.print_area_width * 650) / mockup.template_width < 650 ? (mockup.print_area_left * 650) / mockup.template_width + 0 + 'px': '0px',
                                                            }}
                                                        >
							
                                                            <div className={styles.pa}>Print Area</div>
                                                            <div className={styles.the_close_button}>
                                                                <IoIosCloseCircle size={20} color={'red'} onClick={() => {  removeDesign()}} />
                                                            </div>
                                                        </div>
                                                }
						
                                                <div 
                                                    className={styles.edit_con}
                                                    style={
                                                        window.innerWidth <= 576 ?
                                                            {
                                                                overflow: hidden ? 'hidden' : null,
								display: viewDesignImg? null:'None',
                                                                // display: !showBorder ? 'None' : null,
                                                                zIndex: 10,
                                                                width: (mockup.print_area_width * 350) / mockup.template_width < 350 ? (mockup.print_area_width * 350) / mockup.template_width + 'px': '350px',
                                                               height: (mockup.print_area_height * 350) / mockup.template_height < 350 ?(mockup.print_area_height * 350) / mockup.template_height + 'px': '350px',
                                                                top: (mockup.print_area_height * 350) / mockup.template_height < 350 ?((mockup.print_area_top * 350) / mockup.template_height) + 0 + 'px': '0px',
                                                                left: (mockup.print_area_width * 350) / mockup.template_width < 350? (mockup.print_area_left * 350) / mockup.template_width + 0 + 'px': '0px',
                                                            }
                                                            :
                                                            {
                                                                overflow: hidden ? 'hidden' : null,
								display: viewDesignImg? null:'None',
                                                                // display: !showBorder ? 'None' : null,
                                                                zIndex: 10,
                                                               width: (mockup.print_area_width * 650) / mockup.template_width < 650 ? (mockup.print_area_width * 650) / mockup.template_width + 'px' :  '650px',
                                                                height: (mockup.print_area_height * 650) / mockup.template_height < 650 ? (mockup.print_area_height * 650) / mockup.template_height + 'px' :  '650px',
                                                                top: (mockup.print_area_height * 650) / mockup.template_height < 650 ?((mockup.print_area_top * 650) / mockup.template_height) + 0 + 'px': '0px',
                                                                left:(mockup.print_area_width * 650) / mockup.template_width < 650? (mockup.print_area_left * 650) / mockup.template_width + 0 + 'px': '0px',
                                                            }

                                                    }
                                                >
						<table border={gridShow ? '0' : '1'}  style={
                                                        window.innerWidth > 576 ?{ width:  viewMode ? (mockup.print_area_width * 650) / mockup.template_width + 'px' : (mockup.print_area_width * 650) / mockup.template_width + 'px',
                                                        height: viewMode ? (mockup.print_area_height * 650) / mockup.template_height + 'px' : (mockup.print_area_height * 650) / mockup.template_height + 'px'}
								:
								{ width:  viewMode ? (mockup.print_area_width * 350) / mockup.template_width + 'px': (mockup.print_area_width * 350) / mockup.template_width + 'px',
                                height: viewMode ?(mockup.print_area_height * 350) / mockup.template_height + 'px': (mockup.print_area_height * 350) / mockup.template_height + 'px'}
							    }>
						<tr><td></td><td></td></tr>
						<tr><td></td><td></td></tr>
						</table>
						
						    <div style={{width:'100%', height:'100%'}} id="div_area">
						    <div style={contentStyle} id="edit_area">
						       {
						       designImg &&
                                                        <img
                                                            style={{ zIndex: 1,
                                                                width: '100%', 
                                                            }}
                                                            alt=""
                                                            src={designImg}
                                                            id="designImg"
                                                            ref={dImgRef}
                                                        />
							}
                                                        {
                                                            text &&
                                                            <span style={{
                                                                fontSize: `${fs}px`,
                                                                padding: '0rem',
                                                                display: 'block',
                                                                color: fColor,
                                                                fontWeight: fWeight,
                                                                textAlign: 'center'
                                                            }}>
                                                                {text}
                                                            </span>
                                                        }
							
						</div></div>
						
				   <div style={{zIndex: 1, display: gridShow? 'None': null}}>
						     
                                        <ResizableRectTouch
                                            top={top}
                                            rotatable={true}
                                            left={left}
                                            minWidth={10}
                                            width={width}
                                            minHeight={10}
                                            height={height}
                                            onDrag={handleDrag}
                                            onRotate={handleRotate}
                                            onResize={handleResize}
					    //aspectRatio={false}
                                            zoomable="nw, ne, se, sw , n, w, s, e"
                                            rotateAngle={rotateAngle}
                                        />
                                        </div>
                                                </div>

					 <div 
                                                    className={styles.edit_con}
                                                    style={
                                                        window.innerWidth <= 576 ?
                                                            {
                                                                overflow: hidden ? 'hidden' : null,
								display: viewDesignImg? null:'None',
                                                                // display: !showBorder ? 'None' : null,
                                                                zIndex: 20,
                                                                width: (mockup.print_area_width * 350) / mockup.template_width < 350 ? (mockup.print_area_width * 350) / mockup.template_width + 'px': '350px',
                                                               height: (mockup.print_area_height * 350) / mockup.template_height < 350 ?(mockup.print_area_height * 350) / mockup.template_height + 'px': '350px',
                                                                top: (mockup.print_area_height * 350) / mockup.template_height < 350 ?((mockup.print_area_top * 350) / mockup.template_height) + 0 + 'px': '0px',
                                                                left: (mockup.print_area_width * 350) / mockup.template_width < 350? (mockup.print_area_left * 350) / mockup.template_width + 0 + 'px': '0px',
                                                            }
                                                            :
                                                            {
                                                                overflow: hidden ? 'hidden' : null,
								display: viewDesignImg? null:'None',
                                                                // display: !showBorder ? 'None' : null,
                                                                zIndex: 20,
                                                               width: (mockup.print_area_width * 650) / mockup.template_width < 650 ? (mockup.print_area_width * 650) / mockup.template_width + 'px' :  '650px',
                                                                height: (mockup.print_area_height * 650) / mockup.template_height < 650 ? (mockup.print_area_height * 650) / mockup.template_height + 'px' :  '650px',
                                                                top: (mockup.print_area_height * 650) / mockup.template_height < 650 ?((mockup.print_area_top * 650) / mockup.template_height) + 0 + 'px': '0px',
                                                                left:(mockup.print_area_width * 650) / mockup.template_width < 650? (mockup.print_area_left * 650) / mockup.template_width + 0 + 'px': '0px',
                                                            }

                                                    }
                                                >

						
						  
						
				      <div style={{zIndex: 1, display: gridShow? 'None': null}}>
						     
                                        <ResizableRectTouch
                                            top={top}
                                            rotatable={true}
                                            left={left}
                                            minWidth={10}
                                            width={width}
                                            minHeight={10}
                                            height={height}
                                            onDrag={handleDrag}
                                            onRotate={handleRotate}
                                            onResize={handleResize}
                                            zoomable="nw, ne, se, sw , n, w, s, e"
                                            rotateAngle={rotateAngle}
                                        />
                                        </div>
                                     </div>
				     {
				         viewDesignImg &&
					     <div  className={styles.edit_con}
							    style={{
								top: window.innerWidth <= 576? '370px': '670px',
								width: '100%',
								left: '0px',
								height: '40px',
								background: 'white',
							    }}>
						 <Row>
						      <Col span={3}></Col>
						      <Col span={18}>
							<Slider
							  min={0}
							  max={3}
							  step={0.05}
							  onChange={onChangeSlider}
							  value={typeof inputValue === 'number' ? inputValue : 0}
							/>
						      </Col>
						  </Row>
					     </div>
				     }
                                            </>

                                            :

                                            <div className={styles.upload}>
                                                {/* <label htmlFor="overlayUp">
                                                    UPLOAD DESIGN
                                                </label> */}
                                                <input style={{ display: 'none' }} id='overlayUp' type="file" accept='image/*' onChange={async e => {
						    // setDesignImg(URL.createObjectURL(e.target.files[0]));
						     let fileReader = new FileReader(); 
							fileReader.readAsDataURL(e.target.files[0]); 
							fileReader.onload = function() {
							   //var tt = changeDpiDataUrl(fileReader.result,300);
							   var tt = fileReader.result;
							   let img = new Image()
							    img.src = fileReader.result
							    img.onload = () => {
								if((img.height > mockup.print_area_height) && (img.width > mockup.print_area_width)){
									message.success( "Good to Print");
								}else{
									 message.success( "Bad to Print");
								}
							    }
							    if(product.type === "EMBROIDERY"){
							    	 setDesignImg(tt);
								//getColors(tt);
							    }else{
								 setDesignImg(tt);
							    }
							    
							}; 
							fileReader.onerror = function() {
							  console.log(fileReader.error);
							}; 
                                                }} />
                                            </div>
                                    }
				    
                                </div>
				}
                            </Col>
                        </Row>
                }

                <Modal
                    visible={showCAModal}
                    footer={null}
                    centered={true}
                    width={
                        window.innerWidth <= 576 ? '90vw' : '50vw'
                    }
                    // height={'80vh'}
                    onCancel={() => setShowCAModal(false)}
                >
                    <div>
                        <span style={{ display: 'block', fontWeight: '500', color: 'grey', fontSize: '1.2rem', marginBottom: '1rem' }}>Select Clipart</span>
                        <Row gutter={[20, 20]}>
                            {
                                cliparts.map((art, index) => {
                                    return <Col xs={12} sm={4} key={index} className={styles.cart_wrapper}>
                                        <img
                                            onClick={() => { setDesignImg(art.clipart); setShowCAModal(false) }}
                                            className={styles.cart}
                                            src={art.clipart}
                                            alt=""
                                        />
                                    </Col>
                                })
                            }
                        </Row>
                    </div>
                </Modal>

                <Modal
                    centered={true}
                    visible={showGuide}
                    footer={null}
                    onCancel={() => setShowGuide(false)}
                >
                    <div style={{ marginTop: '1rem' }}>
                        <span style={{ fontSize: '1.2rem' }}>
                            By uploading or saving a design you agree that:
                        </span>
                        <ul style={{ marginTop: '2rem' }}>
                            <li> All content complies with our acceptable Content Guidelines.</li>
                            <li>You hold full rights to commercially reproduce this content.</li>
                            <li> Your content does not express hate towards any person or group.</li>
                            <li>Your content does not promote illegal activities.</li>
                            <li>You understand that we act under your instructions and are not obligated in any way to check or confirm the legal use of reproducing any content.</li>
                            <li>You indemnify and defend Unme for any claims made as a result of alleged infringements.</li>
                        </ul>
                    </div>
                </Modal>
            </section>
             {
                selectedProduct &&
                <ProductModal
                    product={selectedProduct}
                    mockup={mockupData}
                    emockup={eMockupData?eMockupData:""}
                    setSelectedProduct={setSelectedProduct}
                />
            }
	     {
                !designAgree&&viewDesignAgree &&
                <ProductModal2
                    product={viewDesignAgree}
                    setViewDesignAgree={setViewDesignAgree}
		    setDesignAgree={setDesignAgree}
                />
            }
	    {
                blackActionView &&
                <ActionAlert 
		    blackAction={blackAction}
		    blackActionView={blackActionView}
		    setBlackAction={setBlackAction}
		    setBlackActionView={setBlackActionView}
		 />
            }
	    {
                bulePrint &&
                <BulePrint 
		    bulePrint={bulePrint}
		    setBulePrint={setBulePrint}
		 />
            }
        </Layout >
	
    );
};

export default Mockup;